import { render, staticRenderFns } from "./PdlEnergyPriceModule.vue?vue&type=template&id=c2dba324"
import script from "./PdlEnergyPriceModule.vue?vue&type=script&lang=js"
export * from "./PdlEnergyPriceModule.vue?vue&type=script&lang=js"
import style0 from "./PdlEnergyPriceModule.vue?vue&type=style&index=0&id=c2dba324&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports